import React from "react";
import { Routes, Route } from "react-router-dom";
import AddCustomer from "./views/customers/AddCustomer";
import CustomerList from "./views/customers/CustomerList";
import EditCustomer from "./views/customers/EditCustomer";
import ViewCustomerRecord from "./views/customers/ViewCustomerRecord";
import Dashboard from "./views/dashboard/Dashboard";
import AddFleet from "./views/fleet/AddFleet";
import EditFleet from "./views/fleet/EditFleet";
import FleetList from "./views/fleet/FleetList";
import MembershipList from "./views/membership/MembershipList";
import RecentEditOrder from "./views/order/RecentEditOrder";
import Orders from "./views/order/Orders";
import Login from "./views/pages/Login";
import PasswordReset from "./views/pages/PasswordReset";
import Profile from "./views/profile/Profile";
import ServiceList from "./views/services/ServiceList";
import AddService from "./views/services/AddService";
import AddStaff from "./views/staff/AddStaff";
import EditStaff from "./views/staff/EditStaff";
import ManageList from "./views/staff/ManageList";
import EditOrders from "./views/order/EditOrders";
import ViewOrder from "./views/order/ViewOrder";
import AddMembership from "./views/membership/AddMembership";
import Notifications from "./views/notifications/Notifications";
import EditMembership from "./views/membership/EditMembership";
import EditServices from "./views/services/EditServices";
import PrivateRoute from "./PrivateRoute";
import VerifyOTP from "./views/pages/VerifyOTP";
import ChangePassword from "./views/pages/ChangePassword";
import AddStripe from "./views/stripe/addStripe";
import CheckLists from "./views/checklists/CheckLists";
import AddCheckLists from "./views/checklists/AddCheckLists";
import ViewCheckLists from "./views/checklists/ViewCheckLists";
import EditCheckLists from "./views/checklists/EditCheckLists";
import VehicleList from "./views/vehicle/Rentals";
import AddRental from "./views/vehicle/AddRental";
import EditVehicle from "./views/vehicle/EditVehicle";
import RentVehicleList from "./views/rentVehicle/RentVehicleList";
import ViewOrderRentals from "./views/rentVehicle/ViewOrderRentals";
import AddCategory from "./views/checklists/AddCategory";
import EditCategory from "./views/checklists/EditCategory";
import RentalAddOn from "./views/vehicle/RentalAddOn";
import EditRentalAddOn from "./views/vehicle/EditRentalAddOn";
import Discount from "./views/discount/add";
import EditOrderRentals from "./views/rentVehicle/EditOrderRentals";
import UserCustomerLogin from "./views/pages/user-customer-login";
import UserCustomerProfile from "./views/profile/user-customer-profile";
import AddTransitionCharges from "./views/additional/AddTransitionCharges";
import AddSurgePrice from "./views/additional/AddSurgePrice";
import Invoice from "./views/invoice/Invoice";
import InvoiceList from "./views/invoice/InvoiceList";
import ServiceCatalogList from "./views/serviceCatalog/ServiceCatalogList";
import ViewInvoice from "./views/invoice/ViewInvoice";
import EditInvoice from "./views/invoice/EditInvoice";
import AffiliateList from "./views/affiliate/AffiliateList";


const Routing = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route exact={true} path="/" element={<Login />} />
        <Route exact={true} path="/customer-login" element={<UserCustomerLogin />} />
        <Route exact path="/customer-profile" element={<UserCustomerProfile />} />
        <Route
          exact={true}
          path="/password-reset"
          element={<PasswordReset />}
        />
        <Route
          exact={true}
          path="/change-password/:id"
          element={<ChangePassword />}
        />
        <Route exact={true} path="/verify-otp" element={<VerifyOTP />} />
        <Route element={<PrivateRoute />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route
            exact={true}
            path="view-notifications"
            element={<Notifications />}
          />
          <Route exact={true} path="orders" element={<Orders />} />
          <Route exact={true} path="edit-order/:id" element={<EditOrders />} />
          <Route exact={true} path="order-detail/:id" element={<ViewOrder />} />
          <Route
            exact={true}
            path="edit-recent-order/:id"
            element={<RecentEditOrder />}
          />
          <Route exact={true} path="manage-fleet" element={<FleetList />} />
          <Route exact={true} path="add-fleet" element={<AddFleet />} />
          <Route exact={true} path="edit-fleet/:id" element={<EditFleet />} />
          <Route exact={true} path="manage-staff" element={<ManageList />} />
          <Route
            exact={true}
            path="add-membership"
            element={<AddMembership />}
          />
          <Route exact={true} path="discount" element={<Discount />} />
          <Route exact={true} path="add-stripe" element={<AddStripe />} />
          <Route
            exact={true}
            path="edit-membership/:id"
            element={<EditMembership />}
          />

          <Route exact={true} path="add-staff" element={<AddStaff />} />
          <Route exact={true} path="edit-staff/:id" element={<EditStaff />} />
          <Route
            exact={true}
            path="manage-checklists"
            element={<CheckLists />}
          />
          <Route
            exact={true}
            path="view-checklists/:id"
            element={<ViewCheckLists />}
          />
          <Route
            exact={true}
            path="add-checklists"
            element={<AddCheckLists />}
          />
          <Route exact={true} path="add-category" element={<AddCategory />} />
          <Route
            exact={true}
            path="edit-category/:_id"
            element={<EditCategory />}
          />
          <Route
            exact={true}
            path="edit-checklists/:id"
            element={<EditCheckLists />}
          />
          <Route
            exact={true}
            path="manage-customers"
            element={<CustomerList />}
          />
          <Route exact={true} path="add-customer" element={<AddCustomer />} />
          <Route
            exact={true}
            path="edit-customers/:id"
            element={<EditCustomer />}
          />
          <Route
            exact={true}
            path="customer-record/:id"
            element={<ViewCustomerRecord />}
          />
          <Route exact={true} path="manage-service" element={<ServiceList />} />
          <Route
            exact={true}
            path="edit-service/:id"
            element={<EditServices />}
          />
          <Route exact={true} path="add-service" element={<AddService />} />
          <Route
            exact={true}
            path="manage-membership"
            element={<MembershipList />}
          />
          <Route exact={true} path="all-rentals" element={<VehicleList />} />
          <Route
            exact={true}
            path="rental-orders-details/:id"
            element={<ViewOrderRentals />}
          />

          <Route
            exact={true}
            path="rental-orders-edit/:id"
            element={<EditOrderRentals />}
          />

          <Route exact={true} path="add-rental" element={<AddRental />} />
          <Route
            exact={true}
            path="edit-vehicle/:id"
            element={<EditVehicle />}
          />
          <Route
            exact={true}
            path="rental-vehicle-orders"
            element={<RentVehicleList />}
          />
          <Route
            exact={true}
            path="mange-rental-add-on"
            element={<RentalAddOn />}
          />
          <Route
            exact={true}
            path="edit-addon/:id"
            element={<EditRentalAddOn />}
          />
          <Route exact={true} path="profile/:id" element={<Profile />} />
          <Route
            exact={true}
            path="add-transition-charges"
            element={<AddTransitionCharges />}
          />
          <Route
            exact={true}
            path="add-surge-price"
            element={<AddSurgePrice />}
          />
          <Route
            exact={true}
            path="invoice"
            element={<Invoice />}
          />
          <Route
            exact={true}
            path="invoice-list"
            element={<InvoiceList />}
          />
          <Route
            exact={true}
            path="view-invoice/:id"
            element={<ViewInvoice />}
          />
          <Route
            exact={true}
            path="service-catalog"
            element={<ServiceCatalogList />}
          />
          <Route
            exact={true}
            path="manage-affiliates"
            element={<AffiliateList />}
          />
        </Route>
        <Route 
        path="/edit-invoice/:id" 
        element={<EditInvoice />} />  
      </Routes>
    </React.Fragment>
  );
};

export default Routing;
